import { render } from "./statisticModel.vue?vue&type=template&id=f14b8662"
import script from "./statisticModel.vue?vue&type=script&lang=js"
export * from "./statisticModel.vue?vue&type=script&lang=js"

import "./statisticModel.vue?vue&type=style&index=0&id=f14b8662&lang=css"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__